import React from 'react';
// import { TransitionGroup } from 'react-transition-group';
import { Grid } from 'components/grid/Grid';
// import { SearchResultsItem } from './SearchResultsItem';
import { useIntl } from 'react-intl';

import { Segment } from 'components/segment/Segment';
import { Empty } from 'components/card/Empty';
import { NoResults } from 'components/no-results/NoResults';

import s from './SearchResults.scss';

interface IProps {
  children?: React.ReactNode;
  loading?: boolean;
  empty?: boolean;
}

export const SearchResults = ({ children, loading, empty }: IProps) => {
  const items: any = [];
    
  if (loading) {
    for (let i = 0; i < 12; i ++) {
      items.push(<Empty key={i} />);
    };
  };

  const gridContent = loading ? items : children ?? null;
  const intl = useIntl();

  return (
    <div className={s('searchResults', { loading })}>
      {empty ? <NoResults>{intl.formatMessage({ id: 'search.noresults', defaultMessage: 'Ekkert fannst' })}</NoResults>
      : (
        <Segment>
          <Grid>
            {gridContent}
          </Grid>
        </Segment>
      )}
    </div>
  );
};
